import React from 'react';
import styled from 'styled-components';
import { List, Pagination, Empty } from 'antd';
import type { FreePhoto_Base } from '~/common/typescript/models/FreePhoto';
import { FreePhotoListItem } from './FreePhotoListItem';

interface FreePhotoListProps {
  photos: FreePhoto_Base[];
  loading: boolean;
  currentPage: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number, pageSize: number) => void;
  onPhotoView: (photo: FreePhoto_Base) => void;
  onPhotoDownload: (photo: FreePhoto_Base) => void;
}

/**
 * List layout component for displaying FreePhotos
 */
export const FreePhotoList: React.FC<FreePhotoListProps> = ({
  photos,
  loading,
  currentPage,
  pageSize,
  totalCount,
  onPageChange,
  onPhotoView,
  onPhotoDownload,
}) => {
  if (!loading && photos.length === 0) {
    return (
      <UI_EmptyWrapper>
        <Empty description="Không có ảnh nào" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </UI_EmptyWrapper>
    );
  }

  return (
    <UI_Wrapper>
      <List
        dataSource={photos}
        loading={loading}
        renderItem={(photo) => (
          <FreePhotoListItem photo={photo} onView={() => onPhotoView(photo)} onDownload={() => onPhotoDownload(photo)} />
        )}
      />

      {totalCount > pageSize && (
        <UI_PaginationWrapper>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalCount}
            onChange={onPageChange}
            showSizeChanger={false}
            showTotal={(total) => `Tổng ${total} ảnh`}
          />
        </UI_PaginationWrapper>
      )}
    </UI_Wrapper>
  );
};

const UI_Wrapper = styled.div`
  padding: 16px;
`;

const UI_EmptyWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

const UI_PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  padding: 16px 0;
`;
